import {h, Fragment} from "preact"
import { useFacets } from "@nosto/preact"
import Facet from "./Facet"
import FacetColor from "./FacetColor"
import RangeFacet from "./RangeFacet"
import RangeFacetCustom from "./RangeFacetCustom"
import Icon from "./elements/Icon"
import SelectedFiltersCustom from "./SelectedFiltersCustom"
import SelectedFiltersCustomMobile from "./SelectedFiltersCustomMobile"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for="toggle-mobile-sidebar"
        >
            <Icon name="close" className="pd-icon" />
        </label>
    )
}

export default function SideBar({ toggleId }) {
    const { loading, facets } = useFacets()

    return facets?.length > 0 ? (
        <>
            <SelectedFiltersCustomMobile />

            <input type="checkbox" id={toggleId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for="toggle-mobile-sidebar"
            />
            <div
                class="ns-sidebar-wrapper pd-sidebar-wrapper ns-d-none ns-d-md-block ns-h-100 ns-col-3 ns-col-l-2"
                style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline ns-p-4">
                        <span class="ns-font-medium ns-font-5 ns-color-black pd-text-uppercase pd-title-sidebar mobile-only">Filter Options</span>
                        <ToggleSidebarButton />
                    </div>
                    <div class="ns-sidebar-menu pd-sidebar-menu">
                        <SelectedFiltersCustom />
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                
                                switch (facet.type) {
                                    case "terms":
                                        if (facet.name == 'Color') {
                                            return <FacetColor facet={facet} />
                                        } else {
                                            return <Facet facetIn={facet} />
                                        }
                                    case "stats":
                                        if (facet.name == 'Price') {
                                            return <RangeFacetCustom facet={facet} />
                                        } else {
                                            return <RangeFacet facet={facet} />
                                        }
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
